import React from 'react';
import styles from './LabelChip.module.css';

const ALLOWED_COLORS = new Set([
  'neutral',
  'brand',
  'success',
  'info',
  'warning',
  'danger',
  'accent'
]);

export default function LabelChip({
  label,
  color = 'neutral',
  size = 'sm',
  onRemove,
  className = ''
}) {
  const safeColor = ALLOWED_COLORS.has(color) ? color : 'neutral';
  return (
    <span
      className={[
        styles.chip,
        styles[`color-${safeColor}`],
        size === 'md' ? styles.sizeMd : styles.sizeSm,
        className
      ].join(' ')}
    >
      <span className={styles.dot} aria-hidden="true" />
      <span className={styles.label}>{label}</span>
      {onRemove ? (
        <button
          type="button"
          className={styles.remove}
          onClick={onRemove}
          aria-label={`Remove ${label}`}
        >
          ×
        </button>
      ) : null}
    </span>
  );
}
